import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {MenuService} from "../modules/MenuModule";
import {ConfigService} from "../modules/ConfigModule";

class MenuBarController implements IComponentController {
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope, private $menu: MenuService,
                private $config: ConfigService) {
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.menuBar', [])
    .component('menuBar', {
        template: require('./MenuBar.html'),
        controller: MenuBarController,
        bindings: {}
    }).name;
